export default function SatConnectionIcon() {
  return (
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M27.0336 39.4995C17.6336 40.1662 17.6669 53.8329 27.0336 54.4995H49.2669C51.9669 54.5329 54.5669 53.4995 56.5669 51.6995C63.1669 45.9329 59.6336 34.3662 50.9669 33.2662C47.8669 14.4662 20.7003 21.5995 27.1336 39.4995"
        fill="url(#paint0_linear_20801_45155)"
      />
      <path
        opacity="0.4"
        d="M30.0013 75.8337C15.768 75.8337 4.16797 64.2337 4.16797 50.0003C4.16797 48.6337 5.3013 47.5003 6.66797 47.5003C8.03464 47.5003 9.16797 48.6337 9.16797 50.0003C9.16797 59.867 16.0346 68.1337 25.268 70.3003L24.368 68.8003C24.0276 68.2301 23.9277 67.548 24.0902 66.9042C24.2528 66.2603 24.6644 65.7074 25.2346 65.367C25.8049 65.0266 26.4869 64.9267 27.1308 65.0893C27.7747 65.2518 28.3276 65.6634 28.668 66.2337L32.168 72.067C32.6346 72.8337 32.6346 73.8003 32.2013 74.567C31.7346 75.3337 30.9013 75.8337 30.0013 75.8337ZM73.3346 32.5003C71.968 32.5003 70.8346 31.367 70.8346 30.0003C70.8346 20.1337 63.968 11.867 54.7346 9.70033L55.6346 11.2003C55.8032 11.4827 55.9144 11.7954 55.9621 12.1208C56.0097 12.4461 55.9928 12.7777 55.9124 13.0965C55.8319 13.4153 55.6894 13.7151 55.493 13.9789C55.2967 14.2426 55.0503 14.4651 54.768 14.6337C54.4856 14.8022 54.1729 14.9135 53.8475 14.9611C53.5222 15.0088 53.1906 14.9919 52.8718 14.9114C52.553 14.8309 52.2532 14.6884 51.9894 14.4921C51.7257 14.2957 51.5032 14.0493 51.3346 13.767L47.8346 7.93366C47.6085 7.55713 47.4863 7.12735 47.4804 6.68816C47.4745 6.24897 47.5853 5.81609 47.8013 5.43366C48.2346 4.63366 49.068 4.16699 49.968 4.16699C64.2013 4.16699 75.8013 15.767 75.8013 30.0003C75.8057 30.327 75.7452 30.6514 75.6232 30.9545C75.5012 31.2576 75.3202 31.5335 75.0907 31.7661C74.8612 31.9987 74.5878 32.1834 74.2864 32.3094C73.9849 32.4355 73.6614 32.5004 73.3346 32.5003Z"
        fill="url(#paint1_linear_20801_45155)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_20801_45155"
          x1="55.9948"
          y1="38.3374"
          x2="24.5806"
          y2="36.7063"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0BAAA1" />
          <stop offset="1" stopColor="#0B8DAA" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_20801_45155"
          x1="68.6479"
          y1="39.9999"
          x2="12.327"
          y2="37.6373"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0BAAA1" />
          <stop offset="1" stopColor="#0B8DAA" />
        </linearGradient>
      </defs>
    </svg>
  );
}
